import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import YesNoField from './YesNoField';

const colSpan = { lg: 8, xs: 24 };

const InsuranceFee = ({ disabled = false }: { disabled?: boolean }) => {
    const { t } = useTranslation(['financeProductDetails']);

    return (
        <Row gutter={[16, 16]}>
            <Col {...colSpan}>
                <YesNoField
                    {...t('financeProductDetails:fields.insuranceFeeViewable', { returnObjects: true })}
                    disabled={disabled}
                    name="insuranceFee.isViewable"
                />
            </Col>
            <Col {...colSpan}>
                <YesNoField
                    {...t('financeProductDetails:fields.insuranceFeeEditable', { returnObjects: true })}
                    disabled={disabled}
                    name="insuranceFee.isEditable"
                />
            </Col>
        </Row>
    );
};

export default InsuranceFee;
